// extracted by mini-css-extract-plugin
export default {"form":"EditarPedidoBmaFolha_form__Ec2EJ","areaBtn":"EditarPedidoBmaFolha_areaBtn__RDIUF","btn":"EditarPedidoBmaFolha_btn__m5xeU"};